import { render } from "./AdminNav.vue?vue&type=template&id=7a655d29&scoped=true"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=7a655d29&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a655d29"]])

export default __exports__